import { render, staticRenderFns } from "./script-media-list.vue?vue&type=template&id=87adcf66&scoped=true&"
import script from "./script-media-list.vue?vue&type=script&lang=js&"
export * from "./script-media-list.vue?vue&type=script&lang=js&"
import style0 from "./script-media-list.vue?vue&type=style&index=0&id=87adcf66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87adcf66",
  null
  
)

export default component.exports